import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationDataService {

  private urlConfiguration = environment.urlWebServices + '/cwk/configuration';

  constructor(private http: HttpClient) { }

  read(key: string): Observable<any> {
    return this.readValue(key);
  }

  readAll(prefix: string): Observable<any> {

    // Call web service
    const url = `${this.urlConfiguration}/prefix/${encodeURIComponent(prefix)}`;
    return this.http.get(url);
  }

  readValue(key: string): Observable<any> {

    // Call web service
    const url = `${this.urlConfiguration}/value/${encodeURIComponent(key)}`;
    return this.http.get(url);
  }
}
